import { render } from "./NewUserModal.vue?vue&type=template&id=279b53c0&scoped=true"
import script from "./NewUserModal.vue?vue&type=script&lang=js"
export * from "./NewUserModal.vue?vue&type=script&lang=js"

import "./NewUserModal.vue?vue&type=style&index=0&id=279b53c0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279b53c0"]])

export default __exports__